export default __webpack_public_path__ + "static/cardImg1-5b611b0a9d06c31a3e1b5c3528c20a39.webp";